import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { ChevronRight, Menu, X, ArrowUpRight } from 'lucide-react';
import './Aiducators.css';

/* ─── CLIENTS ────────────────────────────────────────────────────────────────── */
const Clients = () => (
  <div className="clients-inner">
    <img src="/images/przychodniadesktop.png" alt="Klient - Przychodnia" />
    <img src="/images/kodanodesktop.png" alt="Klient - Kodano" />
    <img src="/images/jakdojade_h_color_RGB.png" alt="Klient - jakdojade" className="client-logo-lg" />
  </div>
);

/* ─── MAIN COMPONENT ─────────────────────────────────────────────────────────── */
const AIducatorsRedesign = () => {
  const [menu, setMenu] = useState(false);
  const [active, setActive] = useState(0);

  const scroll = (e, id) => {
    e.preventDefault();
    setMenu(false);
    const el = document.getElementById(id);
    const nav = document.querySelector('.site-nav');
    if (el && nav) {
      window.scrollTo({
        top: el.getBoundingClientRect().top + window.scrollY - nav.offsetHeight,
        behavior: 'smooth',
      });
    }
  };

  const navLinks = [
    { label: 'Oferta',   id: 'oferta'  },
    { label: 'Klienci',  id: 'klienci' },
    { label: 'O nas',    id: 'onas'    },
    { label: 'FAQ',      id: 'faq'     },
  ];

  const offers = [
    {
      num: '01',
      title: 'Szkolenia AI',
      sub: 'Budujemy kompetencje Twojego zespołu',
      body: 'Praktyczne szkolenia z AI dopasowane do Twojej branży i poziomu zaawansowania - od podstaw po zaawansowane zastosowania w marketingu, HR, finansach i operacjach. Uczymy narzędzi, które Twój zespół zacznie używać już następnego dnia.',
    },
    {
      num: '02',
      title: 'Wdrożenia AI',
      sub: 'Realna transformacja procesów w firmie',
      body: 'Audytujemy procesy, identyfikujemy obszary do automatyzacji i wdrażamy konkretne rozwiązania AI. Integrujemy narzędzia z istniejącą infrastrukturą, tworzymy dedykowane automaty i systemy - od projektu po gotowe wdrożenie.',
    },
    {
      num: '03',
      title: 'Automatyzacje',
      sub: 'Niech AI pracuje za Twój zespół',
      body: 'Projektujemy i wdrażamy przepływy pracy oparte na AI - od prostych automatyzacji powtarzalnych zadań po złożone systemy agentowe. Łączymy AI z Twoimi aplikacjami, CRM, ERP i komunikatorami, eliminując ręczną pracę tam, gdzie to możliwe.',
    },
  ];

  const methods = [
    {
      name: 'Diagnozowanie',
      desc: 'Analizujemy Twoje procesy i identyfikujemy obszary, w których AI da największy zwrot. Nie szukamy problemów na siłę - wskazujemy miejsca, gdzie technologia realnie oszczędza czas i pieniądze.',
    },
    {
      name: 'Projektowanie',
      desc: 'Projektujemy rozwiązania szyte na miarę - automaty, przepływy pracy, narzędzia AI dopasowane do specyfiki Twojej firmy. Żadnych gotowych szablonów - tylko to, czego naprawdę potrzebujesz.',
    },
    {
      name: 'Wdrażanie',
      desc: 'Implementujemy rozwiązania i integrujemy je z Twoją infrastrukturą - CRM, ERP, komunikatory, bazy danych. Pilnujemy, żeby wszystko działało i szkolimy zespół, który ma tego używać.',
    },
    {
      name: 'Rozwijanie',
      desc: 'AI to nie projekt jednorazowy. Monitorujemy efekty, optymalizujemy działające systemy i rozwijamy automatyzacje wraz z Twoim biznesem. Jesteśmy partnerem na dłużej, nie tylko wykonawcą.',
    },
  ];

  const industries = [
    { tag: 'Marketing',    name: 'AI w marketingu',    benefits: 'Automatyzacja treści, personalizacja kampanii, analiza danych klientów, generowanie kreacji reklamowych.' },
    { tag: 'HR',           name: 'AI w HR',            benefits: 'Automatyzacja rekrutacji, onboarding, analiza zaangażowania, przygotowanie dokumentów i raportów.' },
    { tag: 'Operacje',     name: 'AI w operacjach',    benefits: 'Automatyzacja przepływów pracy, integracja systemów, eliminacja manualnych zadań, monitoring procesów.' },
    { tag: 'Zarządzanie',  name: 'AI dla managerów',   benefits: 'Wsparcie decyzji, automatyczne raporty, analiza danych, prognozowanie i planowanie zasobów.' },
  ];

  const canonicalUrl = 'https://aiducators.pl';

  return (
    <>
      <Helmet>
        <title>Alducators | Profesjonalne szkolenia AI dla firm, marketingu, HR i finansów</title>
        <meta name="description" content="Profesjonalne szkolenia AI, które rewolucjonizują biznes w marketingu, HR i finansach. Alducators – rozwijaj potencjał zespołu!" />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content="Alducators | Profesjonalne szkolenia AI dla firm i managerów" />
        <meta property="og:description" content="Profesjonalne szkolenia AI, które rewolucjonizują biznes." />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Alducators',
            url: canonicalUrl,
            email: 'kontakt@aiducators.pl',
            sameAs: ['https://www.linkedin.com/company/aiducatorspl/'],
          })}
        </script>
      </Helmet>

      {/* Skip link */}
      <a href="#main" className="skip">Przejdź do treści</a>

      {/* ── NAV ── */}
      <nav className="site-nav" role="navigation" aria-label="Główna nawigacja">
        <div className="nav-wrap">
          <a href="/" className="nav-brand">
            <img src="/images/ailong.svg" alt="AIducators" className="nav-logo" />
          </a>

          <div className="nav-items">
            {navLinks.map(l => (
              <a key={l.id} href={`#${l.id}`} className="nav-item" onClick={e => scroll(e, l.id)}>
                {l.label}
              </a>
            ))}
            <a href="#kontakt" className="nav-item-cta" onClick={e => scroll(e, 'kontakt')}>
              Kontakt
            </a>
          </div>

          <button
            className="nav-hamburger"
            onClick={() => setMenu(o => !o)}
            aria-label={menu ? 'Zamknij menu' : 'Otwórz menu'}
            aria-expanded={menu}
          >
            {menu ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

        {menu && (
          <div className="nav-mobile">
            {navLinks.map(l => (
              <a key={l.id} href={`#${l.id}`} onClick={e => scroll(e, l.id)}>
                {l.label}
              </a>
            ))}
            <a href="#kontakt" onClick={e => scroll(e, 'kontakt')}>Kontakt</a>
          </div>
        )}
      </nav>

      {/* ── MAIN ── */}
      <main id="main">

        {/* HERO */}
        <section className="hero">
          <div className="hero-inner">
            <div className="hero-kicker">Transformacja AI dla biznesu</div>
            <h1 className="hero-title">
              Przyszłość Twojego<br />
              biznesu zaczyna się<br />
              od <em>AI</em>
            </h1>
            <div className="hero-bottom">
              <p className="hero-desc">
                Szkolenia, wdrożenia i realna reorganizacja procesów z wykorzystaniem AI.
                Automatyzujemy zadania, tworzymy nowe narzędzia i przeprowadzamy firmy
                przez cyfrową transformację - bez teorii, tylko to, co działa.
              </p>
              <div className="hero-actions">
                <a href="#oferta" className="btn-p" onClick={e => scroll(e, 'oferta')}>
                  Zobacz ofertę <ArrowUpRight size={15} />
                </a>
                <a href="#kontakt" className="btn-o" onClick={e => scroll(e, 'kontakt')}>
                  Porozmawiajmy
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* IMPACT */}
        <section className="section section-stone" aria-labelledby="impact-h">
          <div className="container">
            <div style={{ marginBottom: '2.5rem' }}>
              <div className="section-eyebrow">Dlaczego AI?</div>
              <h2 id="impact-h" className="section-h">AI w liczbach</h2>
            </div>
            <div className="impact-list">
              {[
                { num: '35%', text: 'Wzrostu przychodów dzięki rekomendacjom opartym na AI',              co: 'Amazon'  },
                { num: '80%', text: 'Oglądanych treści pochodzi z rekomendacji generowanych przez AI',    co: 'Netflix' },
                { num: '15%', text: 'Spadek kosztów magazynowania dzięki prognozom dopasowania popytu',  co: 'Walmart' },
              ].map((it, i) => (
                <article className="impact-item" key={i}>
                  <div className="impact-num">{it.num}</div>
                  <p className="impact-text">{it.text}</p>
                  <div className="impact-co">{it.co}</div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* OFFER */}
        <section id="oferta" className="section section-dark" style={{ scrollMarginTop: 64 }} aria-labelledby="offer-h">
          <div className="container">
            <div style={{ marginBottom: '2.5rem' }}>
              <div className="section-eyebrow section-eyebrow-light">Oferta</div>
              <h2 id="offer-h" className="section-h section-h-light">Co robimy dla firm</h2>
            </div>
            <div className="offer-grid">
              <div className="offer-sidebar">
                {offers.map((o, i) => (
                  <div
                    key={i}
                    className={`offer-tab${active === i ? ' active' : ''}`}
                    onClick={() => setActive(i)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && setActive(i)}
                    aria-selected={active === i}
                  >
                    <div>
                      <div className="offer-tab-num">{o.num}</div>
                      <div className="offer-tab-title">{o.title}</div>
                      <div className="offer-tab-sub">{o.sub}</div>
                    </div>
                    <ChevronRight className="offer-tab-arrow" size={16} />
                  </div>
                ))}
              </div>
              <div className="offer-panel" aria-live="polite">
                <div className="offer-panel-tag">Usługa {offers[active].num}</div>
                <div className="offer-panel-title">{offers[active].title}</div>
                <div className="offer-panel-sub">{offers[active].sub}</div>
                <div className="offer-panel-body" key={active}>{offers[active].body}</div>
              </div>
            </div>
          </div>
        </section>

        {/* INDUSTRY */}
        <section className="section" aria-labelledby="industry-h">
          <div className="container">
            <div style={{ marginBottom: '2.5rem' }}>
              <div className="section-eyebrow">Branże</div>
              <h2 id="industry-h" className="section-h">AI w każdym obszarze firmy</h2>
            </div>
            {industries.map((it, i) => (
              <div className="industry-row" key={i}>
                <div className="industry-tag">{it.tag}</div>
                <div>
                  <div className="industry-name">{it.name}</div>
                  <div className="industry-benefits">{it.benefits}</div>
                </div>
                <a href="#kontakt" className="industry-link" onClick={e => scroll(e, 'kontakt')}>
                  Zapytaj <ArrowUpRight size={13} />
                </a>
              </div>
            ))}
          </div>
        </section>

        {/* STATS */}
        <section className="section-sm section-dark" aria-labelledby="stats-h">
          <div className="container">
            <div style={{ marginBottom: '2rem' }}>
              <div className="section-eyebrow section-eyebrow-light">Efektywność</div>
              <h2 id="stats-h" className="section-h section-h-light">Wyniki mówią same za siebie</h2>
            </div>
            <div className="stats-row">
              {[
                { val: '4.85/5', label: 'Średnia ocena naszych szkoleń i wdrożeń'          },
                { val: '430+',   label: 'Przeszkolonych i objętych wdrożeniem specjalistów' },
                { val: '31',     label: 'Zrealizowanych projektów AI dla firm'           },
              ].map((s, i) => (
                <div className="stat-cell" key={i}>
                  <div className="stat-val">{s.val}</div>
                  <div className="stat-label">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CLIENTS */}
        <section id="klienci" className="section-sm" style={{ scrollMarginTop: 64 }} aria-labelledby="clients-h">
          <div className="container">
            <p className="clients-label" id="clients-h">Firmy korzystające z naszych usług</p>
            <div className="clients-bar">
              <Clients />
            </div>
          </div>
        </section>

        {/* METHOD */}
        <section id="onas" className="section section-stone" style={{ scrollMarginTop: 64 }} aria-labelledby="method-h">
          <div className="container">
            <div style={{ marginBottom: '2.5rem' }}>
              <div className="section-eyebrow">Metoda</div>
              <h2 id="method-h" className="section-h">Jak działamy</h2>
            </div>
            {methods.map((m, i) => (
              <div className="method-item" key={i}>
                <div className="method-num-col">
                  <span className="method-num">0{i + 1}</span>
                </div>
                <div className="method-body">
                  <div className="method-title">{m.name}</div>
                  <p className="method-desc">{m.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* FAQ */}
        <section id="faq" className="section" style={{ scrollMarginTop: 64 }} aria-labelledby="faq-h">
          <div className="container" style={{ maxWidth: 840 }}>
            <div style={{ marginBottom: '2.5rem' }}>
              <div className="section-eyebrow">FAQ</div>
              <h2 id="faq-h" className="section-h">Często zadawane pytania</h2>
            </div>
            {[
              {
                q: 'Czym różnicie się od zwykłej firmy szkoleniowej?',
                a: 'Nie tylko szkolimy - wdrażamy. Oznacza to, że po szkoleniu możemy wejść głębiej: zaudytować procesy, zaprojektować automatyzacje i realnie je wdrożyć w Twojej firmie. Łączymy kompetencje trenerskie z technicznymi, dlatego nie zatrzymujemy się na teorii.',
              },
              {
                q: 'Jak wygląda wdrożenie AI w firmie?',
                a: 'Zaczynamy od diagnozy procesów i identyfikacji obszarów, gdzie AI przyniesie największy efekt. Następnie projektujemy rozwiązanie, integrujemy je z Twoimi systemami i wdrażamy. Na końcu szkolimy zespół i monitorujemy efekty. Cały projekt prowadzimy od A do Z.',
              },
              {
                q: 'Czy musicie mieć dostęp do naszych systemów?',
                a: 'Zależy od zakresu projektu. W przypadku samych szkoleń - nie. W przypadku wdrożeń i automatyzacji - zazwyczaj tak, ale zawsze ustalamy zakres dostępów indywidualnie, z poszanowaniem polityki bezpieczeństwa firmy.',
              },
            ].map((f, i) => (
              <details className="faq-item" key={i}>
                <summary>
                  {f.q}
                  <X className="faq-icon" size={16} />
                </summary>
                <p className="faq-answer">{f.a}</p>
              </details>
            ))}
          </div>
        </section>

      </main>

      {/* ── FOOTER / KONTAKT ── */}
      <footer id="kontakt" className="footer-section" style={{ scrollMarginTop: 64 }} role="contentinfo">
        <div className="footer-grid">

          <div>
            <div className="footer-col-title">O firmie</div>
            <div className="footer-brand">Alducators</div>
            <p className="footer-desc">
              Szkolimy, wdrażamy i automatyzujemy. Pomagamy firmom realnie korzystać
              z AI - przez reorganizację procesów, nowe narzędzia i automatyzacje
              dopasowane do każdego biznesu.
            </p>
          </div>

          <address style={{ fontStyle: 'normal' }}>
            <div className="footer-col-title">Kontakt</div>
            <div className="footer-contact-list">
              <div className="footer-contact-item">
                <span className="footer-contact-key">Email</span>
                <span className="footer-contact-val">
                  <a href="mailto:kontakt@aiducators.pl">kontakt@aiducators.pl</a>
                </span>
              </div>
              <div className="footer-contact-item">
                <span className="footer-contact-key">Nazwa</span>
                <span className="footer-contact-val">Alducators</span>
              </div>
              <div className="footer-contact-item">
                <span className="footer-contact-key">NIP</span>
                <span className="footer-contact-val">1133164126</span>
              </div>
            </div>
          </address>

          <nav aria-label="Nawigacja stopki">
            <div className="footer-col-title">Nawigacja</div>
            <div className="footer-nav-list">
              {[...navLinks, { label: 'Kontakt', id: 'kontakt' }].map(l => (
                <a key={l.id} href={`#${l.id}`} className="footer-nav-link" onClick={e => scroll(e, l.id)}>
                  {l.label}
                </a>
              ))}
            </div>
          </nav>

        </div>

        <div className="footer-bottom">
          <span className="footer-copy">
            © {new Date().getFullYear()} Alducators. Wszystkie prawa zastrzeżone.
          </span>
          <div className="footer-social">
            <a
              href="https://www.linkedin.com/company/aiducatorspl/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn - AIducators"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                <rect x="2" y="9" width="4" height="12" />
                <circle cx="4" cy="4" r="2" />
              </svg>
            </a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default AIducatorsRedesign;